<template>
  <div class="my-4" :class="classes" v-if="restaurant.id">
    <div class="flex gap-4 sm:gap-6 items-center bg-mist rounded overflow-hidden">
      <div class="w-1/3 sm:w-1/2 bg-black relative">
        <div class="absolute z-10 bottom-0 left-0 w-full p-3 grid gap-3" v-if="restaurant.logo">
          <div class="relative z-10 w-16 h-8 sm:w-24 sm:h-12 invert" v-if="restaurant.logo">
            <AtomImage class="h-full !object-contain object-left-bottom" :src="useCloudinaryImage(restaurant.logo, 300, null, 'fit,e_trim')" :alt="restaurant.name" />
          </div>
          <div class="absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-25% from-black/80"></div>
        </div>
        <div class="aspect-3/4 sm:aspect-3/2 md:aspect-square">
          <AtomImage class="!object-cover" :src="useCloudinaryImage(restaurant.cover, 600, 400)" :alt="restaurant.name" />
        </div>
      </div>
      <div class="w-2/3 sm:w-1/2 grid gap-1 sm:gap-2 pr-2">
        <h2 class="font-heading font-medium text-xl md:text-4xl">{{ restaurant.name }}</h2>
        <div class="text-sm sm:text-base">
          <AtomRestaurantLocation 
            :name="restaurant.address" 
            :address="restaurant.city"
          />
        </div>
        <div class="flex gap-4 text-xs md:text-sm mt-2">
          <button class="button-coral" @click="useOpenWidget(restaurant.hash)" v-if="restaurant?.bookable">
            {{ $t('shared.bookTable') }}
          </button>
          <NuxtLink class="button-coral-outline" :to="{ name: 'restaurants-slug', params: { slug: restaurant.slug }}" v-if="restaurant?.slug">
            {{ $t('shared.readMore') }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object
})

const classes = [
    props.block.data?.align === 'left' ? 'max-w-3xl' : null, 
    props.block.data?.align === 'center' ? 'w-full max-w-3xl mx-auto' : null,
  ].filter(str => str).join(' ')

const restaurant = computed(() => props.block?.data?.restaurant)
</script>
